import { Box, styled, TextField, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const FieldContentCommonFlex = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
  },
}));

export const CustomTextField = styled(TextField)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? COLORS.WARNING_BG : COLORS.WHITE,
}));
